import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {not_validate_value} from "../App";
import {getLabel} from "../localization/MainLocalization";
import {BaseCheckAndGetEntityPkURL, BaseImportDataURL} from "../urls";
import {httpRequestWithAuth} from "../auth/axios_instance";
import {CustomTextField} from "../components/fields/CustomTextField";
import {ModelsAutoComplete} from "../components/fields/ModelsAutoComplete";
import {DropNDrag} from "../components/DropNDrag";
import {CustomStepper} from "../components/CustomStepper";
import {Hide} from "../components/Hide";
import {ErrorBox} from "../components/ErrorBox";
import Paper from "@material-ui/core/Paper";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import {Loading} from "../components/Loading";

export const ImportData = props => {
    const [data, setData] = useState({});
    const [is_loading, setIsLoading] = useState(false);
    const [view_data, setViewData] = useState({});
    const [helper_text, setHelperText] = useState({});
    const [current_step, setStep] = useState(0);
    const steps = ["enter_entity", "model_&_file", "view_info", "confirm"]

    const handleDataChange = (name, value) => {
        setData({...data, [name]: value})
    }

    const handleNext = async () => {
        await setIsLoading(true);

        if (current_step === 0 && await checkEntityStep()) {
            await setStep(current_step + 1);
        }

        if (current_step === 1 && await checkModelAndFileStep()) {
            await setStep(current_step + 1);
        }

        if (current_step === 2) {
            await setStep(current_step + 1);
        }

        if (current_step === 3 && checkConfirm()) {
            var bodyFormData = new FormData();
            bodyFormData.set("entity", data.entity_pk);
            bodyFormData.append("model", data.model);
            bodyFormData.append("file", data.file);

            let feedback = await httpRequestWithAuth(BaseImportDataURL, "POST", bodyFormData);
            if (feedback.status) {
                await setViewData({...view_data, count: feedback.data})
                await setStep(current_step + 1);
            } else {
                await setHelperText({...feedback.error_feedback});
            }
        }
        await setIsLoading(false);
    };

    const handleBack = () => {
        setStep(current_step - 1);
    };

    const checkEntityStep = async () => {
        const {entity_pk} = data;
        let noError = true;
        let temp_helper_text = {}

        if (not_validate_value.includes(entity_pk)) {
            noError = false
            temp_helper_text = {...temp_helper_text, 'entity_pk': "this field is required!"}
        }


        if (!not_validate_value.includes(entity_pk)) {
            let response = await httpRequestWithAuth(`${BaseCheckAndGetEntityPkURL}${entity_pk}/`);
            if (response.status) {
                await setViewData(response.data);
            } else {
                temp_helper_text = {...temp_helper_text, ...response.error_feedback};
                noError = false;
            }
        }

        if (noError) {
            setHelperText({})
        } else {
            setHelperText(temp_helper_text)
        }
        return noError
    }


    const checkModelAndFileStep = async () => {
        const {model, file} = data;
        let noError = true;
        let temp_helper_text = {}

        if (not_validate_value.includes(model)) {
            noError = false
            temp_helper_text = {...temp_helper_text, 'model': "this field is required!"}
        }

        if (not_validate_value.includes(file)) {
            noError = false
            temp_helper_text = {...temp_helper_text, 'file': "file is required!"}
        }


        if (noError) {
            setHelperText({})
        } else {
            setHelperText(temp_helper_text)
        }
        return noError
    }


    const checkConfirm = () => {
        const {confirm_sub_directory} = data;
        const {sub_directory} = view_data;
        let noError = true;
        let temp_helper_text = {}

        if (confirm_sub_directory !== sub_directory) {
            noError = false
            temp_helper_text = {...temp_helper_text, 'confirm_sub_directory': "Sub directory don't match!!"}
        }


        if (noError) {
            setHelperText({})
        } else {
            setHelperText(temp_helper_text)
        }
        return noError
    }


    const EntityForm = (
        <>
            <Grid item xs={12}>
                <CustomTextField
                    autoComplete="off"
                    required
                    value={data.entity_pk}
                    onChangeHandle={handleDataChange}
                    name="entity_pk"
                    label="entity_pk"
                    helper_text={helper_text.entity_pk}
                    error={helper_text.entity_pk !== undefined}
                />
            </Grid>

        </>
    );


    const EntityDataForm = (
        <>
            <Grid item xs={12} md={6}>
                <CustomTextField
                    value={view_data.id}
                    label="entity_pk"
                    viewOnly
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <CustomTextField
                    value={view_data.company_name}
                    label="company_name"
                    viewOnly
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <CustomTextField
                    value={view_data.business_name}
                    label="business_name"
                    viewOnly
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <CustomTextField
                    value={view_data.sub_directory}
                    label="sub_directory"
                    viewOnly
                />
            </Grid>

            <Grid item xs={12}>
                <ModelsAutoComplete
                    required
                    label="model"
                    name="model"
                    onChangeHandle={handleDataChange}
                    error={helper_text.model !== undefined}
                    helper_text={helper_text.model}
                    value={data.model}
                />
            </Grid>

            <Grid item xs={12}>
                <DropNDrag
                    name="file"
                    onChangeHandle={handleDataChange}
                    value={data.file}
                    error={helper_text.file !== undefined}
                    helper_text={helper_text.file}
                />
            </Grid>

        </>
    );


    let ViewInfo = (
        <>

            <Grid container spacing={2} className="pl-3 pr-3 text-center">

                <Grid item xs={12} sm={6}>
                    <Typography variant="h5" className="text-black-50">
                        {getLabel('entity_pk')}
                    </Typography>

                    <Typography variant="h6">
                        {view_data.id}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Typography variant="h5" className="text-black-50">
                        {getLabel('company_name')}
                    </Typography>
                    <Typography variant="h6">
                        {view_data.company_name}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Typography variant="h5" className="text-black-50">
                        {getLabel('business_name')}
                    </Typography>
                    <Typography variant="h6">
                        {view_data.business_name}
                    </Typography>
                </Grid>


                <Grid item xs={12} sm={6}>
                    <Typography variant="h5" className="text-black-50">
                        {getLabel('sub_directory')}
                    </Typography>
                    <Typography variant="h6">
                        {view_data.sub_directory}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Typography variant="h5" className="text-black-50">
                        {getLabel('model')}
                    </Typography>
                    <Typography variant="h6">
                        {data.model}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Typography variant="h5" className="text-black-50">
                        {getLabel('file')}
                    </Typography>
                    <Typography variant="h6">
                        {not_validate_value.includes(data.file) ? "" : data.file.name}
                    </Typography>
                </Grid>

            </Grid>
        </>
    );

    const confirmationForm = (
        <Grid item xs={12}>
            <CustomTextField
                autoComplete="off"
                required
                value={data.confirm_sub_directory}
                onChangeHandle={handleDataChange}
                name="confirm_sub_directory"
                label="write_entity_sub_director_to_confirm_the_process"
                helper_text={helper_text.confirm_sub_directory}
                error={helper_text.confirm_sub_directory !== undefined}
            />
        </Grid>
    )

    let successfulForm = (
        <>
            <Grid item xs={12}
                  className="fixedHeight-200 text-success d-inline-flex justify-content-center align-items-center">
                <CheckCircleOutlineIcon className="h-100 w-auto"/>

                <Typography variant="h4">
                    {`${view_data.count} ${data.model} `}has been imported successfully
                </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
                <Button
                    variant="outlined"
                    color="primary"
                    className="w-100"
                    onClick={() => {
                        setData({entity_pk: data.entity_pk});
                        setViewData({...view_data, count:undefined})
                        setStep(1);
                    }}>
                    Import Other model with same entity
                </Button>
            </Grid>


            <Grid item xs={12} md={6}>
                <Button
                    variant="outlined"
                    color="primary"
                    className="w-100"
                    onClick={() => {
                        setData({});
                        setViewData({});
                        setStep(0);
                    }}>
                    New Import
                </Button>
            </Grid>
        </>
    )

    return (
        <Paper className="flex-column align-items-center d-flex Paper">

            <Grid container spacing={2} className="mt-5">

                <CustomStepper
                    current_step={current_step}
                    steps={steps}
                />
                <Hide hide={!is_loading}>
                    <Loading/>
                </Hide>

                <Hide hide={is_loading}>
                    <Hide hide={current_step !== 0}>
                        {EntityForm}
                    </Hide>

                    <Hide hide={current_step !== 1}>
                        {EntityDataForm}
                    </Hide>


                    <Hide hide={current_step !== 2}>
                        {ViewInfo}
                    </Hide>

                    <Hide hide={current_step !== 3}>
                        {confirmationForm}
                    </Hide>

                    <Hide hide={current_step !== 4}>
                        {successfulForm}
                    </Hide>


                    <ErrorBox
                        errorMsg={helper_text.non_field_errors}
                    />

                    <Hide hide={steps.length <= current_step}>
                        <div className="d-inline-flex w-100">
                            <Hide hide={current_step === 0}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="m-3"
                                    onClick={handleBack}
                                >
                                    {getLabel("back")}
                                </Button>
                            </Hide>

                            <div className="mr-auto"/>

                            <Button
                                variant="contained"
                                color="primary"
                                className="m-3"
                                onClick={handleNext}
                            >
                                {getLabel(steps.length - 1 === current_step ? "submit" : "next")}
                            </Button>

                        </div>
                    </Hide>
                </Hide>

            </Grid>

        </Paper>
    );
}